/* AK-Custom made – animierter Nebel-Hintergrund im Hero (WebGL).
   Dunkler Nebel nur um die Bilder herum, die Mitte bleibt schwarz.
   Styles dazu: assets/ak-polish.css. Ohne diese Datei bleibt alles statisch. */
(function () {
  'use strict';

  const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const MAX_PIXEL_RATIO = 1.5;

  const VERTEX_SHADER = 'attribute vec2 a;void main(){gl_Position=vec4(a,0.,1.);}';
  const FRAGMENT_SHADER = [
    // Handys rechnen mit "mediump" zu ungenau fürs Rauschen -> highp, wo vorhanden
    '#ifdef GL_FRAGMENT_PRECISION_HIGH',
    'precision highp float;',
    '#else',
    'precision mediump float;',
    '#endif',
    'uniform vec2 r;uniform float t;',
    'float h(vec2 p){vec3 q=fract(vec3(p.xyx)*.1031);q+=dot(q,q.yzx+33.33);return fract((q.x+q.y)*q.z);}',
    'float n(vec2 p){vec2 i=floor(p),f=fract(p);f=f*f*(3.-2.*f);',
    'return mix(mix(h(i),h(i+vec2(1.,0.)),f.x),mix(h(i+vec2(0.,1.)),h(i+vec2(1.,1.)),f.x),f.y);}',
    'float fbm(vec2 p){float v=0.,a=.5;for(int i=0;i<5;i++){v+=a*n(p);p=p*2.03+vec2(1.7,9.2);a*=.5;}return v;}',
    'void main(){',
    'vec2 p=(gl_FragCoord.xy-.5*r)/r.y;',
    'float w=fbm(p*1.3+vec2(t*.03,-t*.02));',
    'float f=fbm(p*2.+w*1.8+vec2(-t*.025,t*.035));',
    // Unteren Nebel dezent von rechts nach links ausgleichen.
    'float lower=1.-smoothstep(-.25,.45,p.y);',
    'f-=clamp(p.x,-.8,.8)*.08*lower;',
    // dunkler Nebel: Anthrazit bis Rauchgrau mit leicht kühlem Ton
    'float smoke=smoothstep(.28,.84,f);',
    'vec3 col=mix(vec3(.018,.022,.027),vec3(.16,.18,.2),smoke);',
    'col=mix(col,vec3(.3,.32,.34),pow(smoke,3.)*.3);',
    // Mitte bleibt für die Motive schwarz und wird leicht nach oben versetzt.
    // Auf schmalen Bildschirmen wird die Aussparung entsprechend kleiner.
    'float k=clamp(r.x/r.y*.5,.5,1.);',
    'col*=smoothstep(.14*k,.52*k,length((p-vec2(0.,.03))*vec2(.72,1.)));',
    // Sanfte Vignette statt vollständig schwarzer Außenränder
    'float vignette=1.-smoothstep(.48,1.35,length(p*vec2(.78,1.12)));',
    'col*=mix(.68,1.,vignette);',
    'col+=(h(gl_FragCoord.xy+fract(t)*91.7)-.5)*.012;',
    'gl_FragColor=vec4(col,1.);}',
  ].join('\n');

  function compileShader(gl, type, source) {
    const shader = gl.createShader(type);
    gl.shaderSource(shader, source);
    gl.compileShader(shader);
    if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
      throw new Error(gl.getShaderInfoLog(shader) || 'Shader-Fehler');
    }
    return shader;
  }

  function initHeroBackground(stage) {
    const canvas = document.createElement('canvas');
    canvas.className = 'ak-hero-fx';
    canvas.setAttribute('aria-hidden', 'true');
    const gl = canvas.getContext('webgl', { antialias: false, alpha: false, powerPreference: 'low-power' });
    if (!gl) return;

    let program;
    try {
      program = gl.createProgram();
      gl.attachShader(program, compileShader(gl, gl.VERTEX_SHADER, VERTEX_SHADER));
      gl.attachShader(program, compileShader(gl, gl.FRAGMENT_SHADER, FRAGMENT_SHADER));
      gl.linkProgram(program);
      if (!gl.getProgramParameter(program, gl.LINK_STATUS)) throw new Error('Programm-Fehler');
    } catch (error) {
      console.warn('AK-FX: WebGL-Hintergrund deaktiviert –', error.message);
      return;
    }

    gl.useProgram(program);
    gl.bindBuffer(gl.ARRAY_BUFFER, gl.createBuffer());
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
    const position = gl.getAttribLocation(program, 'a');
    gl.enableVertexAttribArray(position);
    gl.vertexAttribPointer(position, 2, gl.FLOAT, false, 0, 0);
    const uResolution = gl.getUniformLocation(program, 'r');
    const uTime = gl.getUniformLocation(program, 't');

    stage.insertBefore(canvas, stage.firstChild);
    stage.classList.add('ak-hero-fx-on');

    const resize = () => {
      const ratio = Math.min(window.devicePixelRatio || 1, MAX_PIXEL_RATIO);
      const width = Math.max(1, Math.round(stage.clientWidth * ratio));
      const height = Math.max(1, Math.round(stage.clientHeight * ratio));
      if (canvas.width === width && canvas.height === height) return;
      canvas.width = width;
      canvas.height = height;
      gl.viewport(0, 0, width, height);
    };

    const draw = (seconds) => {
      resize();
      gl.uniform2f(uResolution, canvas.width, canvas.height);
      gl.uniform1f(uTime, seconds);
      gl.drawArrays(gl.TRIANGLES, 0, 3);
    };

    if (REDUCED_MOTION) {
      draw(0);
      window.addEventListener('resize', () => draw(0));
      return;
    }

    const animationStartedAt = performance.now();
    let visible = true;
    let frame = 0;
    const loop = (now) => {
      frame = 0;
      if (!visible || document.hidden) return;
      draw((now - animationStartedAt) / 1000);
      frame = requestAnimationFrame(loop);
    };
    const start = () => {
      if (!frame) frame = requestAnimationFrame(loop);
    };
    new IntersectionObserver((entries) => {
      visible = entries[0].isIntersecting;
      if (visible) start();
    }).observe(stage);
    document.addEventListener('visibilitychange', start);
    start();
  }

  function init() {
    const stage = document.querySelector('.ak-hero-composite__stage');
    if (stage) {
      initHeroBackground(stage);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
